import React from "react"
import './Header.css'

import logoImg from './imgs/logoPlanet.png'


export default function Header() {
    return(

        <div className="header">
        
            <div className="content_header">
            
                <img src={logoImg} alt="#" className='logo_header' />

                <p className="p_header">

                    Data transforms the world and the world needs change.

                </p>

            </div>

        </div>

    )
}